import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";

// Firebase configuration - NO analytics to respect privacy policy
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // Realtime Database URL
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
};

const requiredKeys = [
  "apiKey",
  "authDomain",
  "projectId",
  "storageBucket",
  "messagingSenderId",
  "appId",
  "databaseURL"
];

const hasAllConfig = requiredKeys.every((key) => Boolean(firebaseConfig[key]));

if (!hasAllConfig) {
  console.warn(
    "Firebase config is missing. Set REACT_APP_FIREBASE_* env vars to enable TV sync."
  );
}

// Initialize Firebase only when config is present
const app = hasAllConfig ? initializeApp(firebaseConfig) : null;

// Initialize Realtime Database
export const database = app ? getDatabase(app) : null;

// Initialize Firebase Auth (anonymous) for RTDB rules that require auth
export const auth = app ? getAuth(app) : null;
let authReadyPromise = null;

export const ensureSignedIn = () => {
  if (!auth) return Promise.resolve(null);
  if (authReadyPromise) return authReadyPromise;

  authReadyPromise = new Promise((resolve) => {
    let resolved = false;
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        if (!resolved) {
          resolved = true;
          unsubscribe();
          resolve(user);
        }
        return;
      }
      try {
        await signInAnonymously(auth);
      } catch (error) {
        console.error("Anonymous Firebase auth failed:", error);
        if (!resolved) {
          resolved = true;
          unsubscribe();
          authReadyPromise = null; // Reset so the next call retries instead of returning cached null
          resolve(null);
        }
      }
    });
  });

  return authReadyPromise;
};
